import { render, staticRenderFns } from "./SearchGSC.vue?vue&type=template&id=fa0433c4&"
import script from "./SearchGSC.vue?vue&type=script&lang=js&"
export * from "./SearchGSC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports